// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";

import PropTypes from "prop-types";

import { Header } from "components/elements";
import { classes } from "utils/classes";

import styles from "./subsection.scss";

/**
 * Generic component that groups similar content. Should be child of `<Section>`.
 */
export class Subsection extends Component {
  static propTypes = {
    children: PropTypes.node,
    header: PropTypes.node,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    tooltip: PropTypes.string,
  };

  static defaultProps = {
    dataTestId: "subsection",
  };

  render() {
    const { children, header, className, tooltip, dataTestId } = this.props;

    return (
      <div
        className={classes(styles.subSection, className)}
        data-test-id={dataTestId}
      >
        {header ? (
          <Header
            className={styles.header}
            type="h6"
            uppercase={true}
            color="tertiary"
            tooltip={tooltip}
          >
            {header}
          </Header>
        ) : null}
        <div className={styles.children} data-test-id={`${dataTestId}-content`}>
          {children}
        </div>
      </div>
    );
  }
}

export default Subsection;
